<template>
  <div class="upload-video-container">
    <!-- 视频预览区域 -->
    <div v-if="previewUrl" class="video-preview">
      <video 
        :src="previewUrl" 
        controls 
        preload="metadata"
        style="max-width: 100%; max-height: 200px; border-radius: 4px;"
      >
        您的浏览器不支持视频播放
      </video>
      <div class="video-info">
        <span class="video-name">{{ getVideoName(previewUrl) }}</span>
        <el-button 
          type="danger" 
          size="small" 
          @click="handleRemove"
          style="margin-left: 8px;"
        >
          删除
        </el-button>
      </div>
    </div>
    
    <!-- 上传组件 -->
    <el-upload
      v-if="!previewUrl"
      :file-list="fileList"
      :on-remove="handleRemove"
      :http-request="uploading"
      :limit="1"
      :headers="headers"
      :data="data"
      list-type="text"
      accept="video/*"
      :show-file-list="false"
      :auto-upload="true"
      @change="handleFileChange"
    >
      <el-button type="primary">
        <el-icon><Plus /></el-icon>
        上传视频
      </el-button>
    </el-upload>
  </div>
</template>

<script setup>
import { base_img } from '../../api/config'
import OSS from 'ali-oss'
import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { getFileExt } from '../../utils/file_util'
import { Plus } from '@element-plus/icons-vue'

const store = useStore()
const headers = { token: store.getters.token }
const data = { uploadType: 'banner', durable: 1 }
const fileList = ref([])
const previewUrl = ref('')
let credentials = null
let ossClient = null
const bucket = 'birdseye'
const region = 'oss-cn-guangzhou'

const props = defineProps({
  limit: {
    type: Number,
    default: 1
  },
  fullPath: {
    type: Boolean,
    default: false
  },
  url: {
    type: String,
    default: null
  },
  name: {
    type: String,
    default: new Date().getTime()
  },
  filename: {
    type: String,
    default: new Date().getTime()
  }
})

// 监听 url 变化，设置预览
watch(() => props.url, (newUrl) => {
  if (newUrl) {
    previewUrl.value = newUrl
  }
}, { immediate: true })

// 初始化时设置预览
if (props.url) {
  previewUrl.value = props.url
}

const emit = defineEmits(['uploadSuccess', 'handleRemove'])

const handleRemove = () => {
  previewUrl.value = ''
  fileList.value = []
  emit('handleRemove', props.name)
}

// 处理文件选择变化
const handleFileChange = (file) => {
  if (file && file.raw) {
    // 创建本地预览URL
    previewUrl.value = URL.createObjectURL(file.raw)
  }
}

async function uploading(option) {
  if (!ossClient) {
    await initOSSClient()
  }
  const file = option.file
  const ext = getFileExt(file.name)
  const fileName = props.filename + '.' + ext

  return ossClient
    .put(fileName, file)
    .then((result) => {
      const finalUrl = props.fullPath ? `${base_img}/${result.name}` : result.name
      previewUrl.value = finalUrl
      emit('uploadSuccess', finalUrl, props.name)
    })
    .catch((err) => {
      console.log(`Video upload ${file.name} failed === `, err)
    })
}

function getCredential() {
  return VE_API.ali
    .credential()
    .then(({ data }) => {
      credentials = data
      initOSSClient()
    })
}
getCredential()

async function initOSSClient() {
  const { accessKeyId, accessKeySecret, securityToken } = credentials
  ossClient = new OSS({
    accessKeyId: accessKeyId,
    accessKeySecret: accessKeySecret,
    stsToken: securityToken,
    bucket,
    region
  })
}

// 获取视频名称
const getVideoName = (url) => {
  if (!url) return ''
  const fileName = url.split('/').pop()
  return fileName || '视频文件'
}

</script>

<style scoped>
.upload-video-container {
  width: 100%;
}

.video-preview {
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  padding: 12px;
  background: #fafafa;
}

.video-info {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.video-name {
  font-size: 14px;
  color: #606266;
  word-break: break-all;
  flex: 1;
  margin-right: 8px;
}
</style>


